import { GroupTableType } from "helpers/models";

function paginate(grouped: GroupTableType, count: number = 10) {
  const keys = Object.keys(grouped);
  const result: GroupTableType[] = [];
  
  for (let i = 0; i < keys.length; i += count) {
    const pageData: GroupTableType = {};
    const slice = keys.slice(i, i + count);

    slice.forEach((key) => {
      pageData[key] = grouped[key];
    });
    result.push(pageData);
  }
  return result;
}

export default paginate;
